export function matchHeight(selector) {
  const element = document.querySelectorAll(selector);
  let height = 0,
    width,
    parentWidth,
    fullWidth = false,
    b;
  
  for (let i = 0; i < element.length; i++) {
    element[i].style.height = 'auto';
  }
  
  for (let i = 0; i < element.length; i++) {
    b = element[i];
    parentWidth = b.parentNode.offsetWidth;
    width = b.offsetWidth;
    if (parentWidth < width + 40) {
      fullWidth = true;
      break;
    }
    
    height = b.offsetHeight > height ? b.offsetHeight : height;
  }
  
  for (let i = 0; i < element.length; i++) {
    element[i].style.height = fullWidth ? 'auto' : height + 'px';
  }
}

export function onTemplateLoad() {
  window.scrollTo(0,0)
}



// WEBPACK FOOTER //
// ./src/components/Shared/Commons.js